import { BabylonState } from "../../state";

import { logTimeBinarySearch } from "./setPositionsToTime";

/**
 * Resolves which message each point cloud should show at the current time:
 * the latest message at or before it, or nothing before the first message.
 *
 * Bookkeeping only — one binary search per cloud, no allocation, no fetch. The
 * reload poll reads `wanted` and does the fetching, so a scrub that passes
 * through ten messages between two polls asks for one frame, not ten.
 */
export function updatePointClouds(state: BabylonState) {
  const time = state.sceneConfig.time;
  if (time === undefined) {
    return;
  }
  for (const entity of Object.values(state.entities)) {
    const cloud = entity.pointCloud;
    if (!cloud || cloud.index.load.state !== "loaded") {
      continue;
    }
    const logtimes = cloud.index.logtimes;
    cloud.wanted =
      logtimes.length === 0 || time < logtimes[0]
        ? undefined
        : logtimes[logTimeBinarySearch(logtimes, time)];
  }
}
